<template>
  <!-- 课程资料 -->
  <div class="main-contain">
    <div class="course-intro-content">
      <div class="intro-title">
        <el-image :src="courseImg" class="title-icon" />
        <div class="title-text"><span>课程资料</span></div>
      </div>
      <div class="contain course_contain">
        <el-page-header @back="goBack" v-if="file_name != ''" :content="file_name"></el-page-header>

        <!-- 统计卡片 -->
        <div class="stat-cards">
          <div class="stat-card all">
            <div class="card-info">
              <div class="card-label">全部资料</div>
              <div class="card-value all">{{ stats.all }}</div>
            </div>
            <!-- <div class="card-icon"></div> -->
          </div>
          <div class="stat-card video">
            <div class="card-info">
              <div class="card-label">视频资料</div>
              <div class="card-value video">{{ stats.video }}</div>
            </div>
            <!-- <div class="card-icon"></div> -->
          </div>
          <div class="stat-card doc">
            <div class="card-info">
              <div class="card-label">文档资料</div>
              <div class="card-value doc">{{ stats.doc }}</div>
            </div>
            <!-- <div class="card-icon"></div> -->
          </div>
          <div class="stat-card other">
            <div class="card-info">
              <div class="card-label">其他资料</div>
              <div class="card-value other">{{ stats.other }}</div>
            </div>
            <!-- <div class="card-icon"></div> -->
          </div>
          <!-- <div class="stat-card total">
            <div class="card-info">
              <div class="card-label">查看总量</div>
              <div class="card-value total">{{ stats.viewTotal | formatNumber }}<span class="card-unit">次</span></div>
            </div>
          </div> -->
        </div>

        <!-- 文件列表 -->
        <div class="file-list" v-loading="loading">
          <div class="file-item" v-for="row in tableData" :key="row.id">
            <div class="file-info">
              <el-image class="file-icon" :src="file_icon(row.ext)" />
              <div class="file-meta">
                <div class="file-name">{{ row.name }}</div>
                <div class="file-size" v-if="row.file_type == 1">{{ row.size }}</div>
              </div>
            </div>
            <div class="file-actions">
              <el-button class="btn-preview" v-if="row.file_type" @click="lookbt(row)">
                <i class="btn-icon preview-icon"></i>
                <span class="download-text">预览</span>
              </el-button>
              <el-button class="btn-download" v-if="row.file_type" @click="downloadRow(row)">
                <i class="btn-icon download-icon"></i>
                <span class="download-text">下载</span>
              </el-button>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="page_total" v-if="isMobile == 1 && total > 0">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" :current-page="page"
            @current-change="pageChange"></el-pagination>
        </div>
        <div class="page_total" v-if="isMobile == 0 && total > 0">
          <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" :pager-count="5"
            :current-page="page" @current-change="pageChange"></el-pagination>
        </div>

        <!-- 右下角装饰 -->
        <!-- <div class="decoration-bottom"></div> -->
      </div>
      <Customdialog ref="customdialog" class="customdialog" :width="seeFilesWidth" type="form" title="预览"
        :showclose="true" @isDialogClose="close_dialog">
        <div class="dialogbody" slot="dialogbody">
          <template v-if="type == '视频'">
            <video class="video_view" ref="vueRef" :src="videoviewurl" controls controlslist="nodownload noplaybackrate"
              disablepictureinpicture width="100%" height="500" @contextmenu.prevent="handleRMouse" />
          </template>
          <template v-if="type == '图片'">
            <!-- <el-image class="image_view" :src="imageviewurl" fit="contain" /> -->
            <iframe class="iframe_cont" :src="imageviewurl" frameborder="0" ref="myiframe"></iframe>
          </template>
          <template v-if="type == '其他'">
            <!-- <div class="tip_con">
              <div class="icon">!</div>
              <div class="tip_tex">
                该文件暂时不支持在线预览，您可以下载后查看！
              </div>
            </div>-->
            <iframe class="iframe_cont" :src="file_url" frameborder="0" ref="myiframe"></iframe>
          </template>
          <template v-if="type == 'PDF'">
            <!-- <div class="pdf_con">
              <md-contract :url="fileurl" :visible="contractVisable" :showBtns="true" @handleModal="close">
              </md-contract>
            </div>-->
            <iframe class="iframe_cont" :src="fileurl" frameborder="0" ref="myiframe"></iframe>
          </template>
          <div id="toolbar" :class="toolbar == false ? 'tool-box doc_1' : 'tool-box'" style="visibility: visible">
            <div class="line-bar1"></div>
            <div class="full-box">
              <a class="full-btn1" @click="screen">
                <i class="el-icon-full-screen" style="font-size: 17px"></i>
                <span style="margin-left: 4px">全屏</span>
              </a>
              <!-- <a class="full-btn2" @click="fullScreen" style="display:none">
                <i class="iconfont"></i><span style="margin-left:4px">退出全屏</span>
              </a>-->
            </div>
          </div>
        </div>
        <div slot="dialogfooter" class="dialogfooter">
          <el-button type="primary" @click="download" v-if="!is_download">下载</el-button>
          <el-button type="info" @click="close_down">关闭</el-button>
        </div>
      </Customdialog>
    </div>
  </div>
</template>
<script>
import pagTable from "@/components/Pagination/pagTable"
import Customdialog from "@/components/customdialog.vue"
import { getattachmentlist } from "@/api/attachment"
import { Base64 } from "js-base64"
import screenfull from "screenfull"
const request_base_path = require("@/utils/base_url")
export default {
  name: "virtualexperiment",
  components: {
    pagTable,
    Customdialog,
  },
  data() {
    return {
      filePreview: "", // 数据预览
      picturesPreview: "", // 多图预览
      fileTask: "", // 数据预埋
      fileurl: "",
      file_url: "",
      type: "",
      testimage: require("@/assets/test.png"),
      // icon1: require("@/assets/coursedetails/文件类型-标准图-视频文件.png"),
      // icon2: require("@/assets/coursedetails/矢量智能对象 (1).png"),
      courseKey: "",
      tableData: [],
      per_page: 10, // 每页条数
      page: 1,
      total: 0,
      imageviewurl: "",
      imageviewurlList: [], // 图片数据
      isImg: ["jpg", "png", "jpeg", "gif", "webp", "ico"],
      isdoc: ["word", "docx", "doc"],
      isVideo: [
        "mp4",
        "rmvb",
        "vob",
        "avi",
        "wmv",
        "flv",
        "mkv",
        "webm",
        "mov",
      ],
      // fileicon1: require("@/assets/course/UIout/fileicon/files.png"),
      fileicon2: require("@/assets/course/UIout/fileicon/pdf.png"),
      fileicon3: require("@/assets/course/UIout/fileicon/word.png"),
      fileicon4: require("@/assets/course/UIout/fileicon/mp4_ico.png"),
      fileicon5: require("@/assets/course/UIout/fileicon/img_ico.png"),
      fileicon6: require("@/assets/fileicon/icon-node.png"),
      fileicon7: require("@/assets/fileicon/icon-audio.png"),
      fileicon8: require("@/assets/fileicon/icon-chapter.png"),
      fileicon9: require("@/assets/fileicon/rar.png"),
      fileicon10: require("@/assets/course/UIout/fileicon/other_btn.png"),
      fileicon11: require("@/assets/course/UIout/fileicon/txt.png"),
      fileicon12: require("@/assets/course/UIout/fileicon/excel.png"),
      fileicon13: require("@/assets/fileicon/zip.png"),
      is_download: 0,
      itemObj: {},
      file_name: "",
      fullscreen: false, //全屏
      toolbar: false,
      loading: true,
      seeFilesWidth: "",
      isMobile: "",
      videoviewurl: "",
      courseImg: require("@/assets/course/UIout/courseintro/courseintro_decor_01.png"),
      stats: {
        all: 0,
        video: 0,
        doc: 0,
        other: 0,
        viewTotal: 2345
      }
    }
  },
  filters: {
    formatNumber(val) {
      return val ? val.toLocaleString() : '0'
    }
  },
  created() {
    const systemConfig = sessionStorage.getItem("systemConfig")
    const systemInfo = systemConfig ? JSON.parse(systemConfig) : {}
    if (systemInfo.file_preview_url) {
      this.filePreview = systemInfo.file_preview_url + "/onlinePreview?url=" // 数据预览
      this.picturesPreview = systemInfo.file_preview_url + "/picturesPreview?urls=" // 多图预览
      this.fileTask = systemInfo.file_preview_url + "/addTask?url=" // 数据预埋
    } else {
      this.filePreview = request_base_path.pro_url + "/file-preview/onlinePreview?url=" // 数据预览
      this.picturesPreview = request_base_path.pro_url + "/file-preview/picturesPreview?urls=" // 多图预览
      this.fileTask = request_base_path.pro_url + "/file-preview/addTask?url=" // 数据预埋
    }
    if (this._isMobile()) {
      this.isMobile = 0
      this.seeFilesWidth = 100 + "%"
    } else {
      this.isMobile = 1
      this.seeFilesWidth = 70 + "%"
    }
  },
  methods: {
    initdata(obj, courseKey) {
      console.log("课程资料", obj, courseKey)
      if (courseKey) {
        this.courseKey = courseKey
        this.getattachmentlist()
      }
    },
    // 判断手机端
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    handleRMouse(e) {
      e.preventDefault()
    },
    file_icon(val) {
      if (val == "pdf") {
        return this.fileicon2
      } else if (this.isdoc.includes(val)) {
        return this.fileicon3
      } else if (this.isVideo.includes(val)) {
        return this.fileicon4
      } else if (this.isImg.includes(val)) {
        return this.fileicon5
      } else if (val == "radio") {
        return this.fileicon7
      } else if (val == "rar") {
        return this.fileicon9
      } else if (val == "txt") {
        return this.fileicon11
      } else if (val == "xlsx") {
        return this.fileicon12
      } else if (val == "zip") {
        return this.fileicon13
      } else {
        return this.fileicon10
      }
    },
    async lookbt(item) {
      this.resetFill()
      await this.getTask(item.url)
      if (item.ext == "mp4" || item.ext == "avi" || item.ext == "flv") {
        this.type = "视频"
        this.videoviewurl = item.url
        this.toolbar = false
      } else if (this.isImg.includes(item.ext)) {
        this.type = "图片"
        let len = this.imageviewurlList.length
        for (let i = 0; i < len; i++) {
          if (this.imageviewurlList[i] == item.url) {
            let newArr = this.imageviewurlList.splice(i, len - i)
            let oldArr = this.imageviewurlList
            this.imageviewurlList = [...newArr, ...oldArr]
            break
          }
        }
        // console.log('2023', this.imageviewurlList);
        // alert('11111')
        let url = this.imageviewurlList.join("|")
        this.imageviewurl =
          this.picturesPreview + encodeURIComponent(Base64.encode(url))
        //window.open(this.imageviewurl,'_blank');
        this.toolbar = true
      } else if (item.ext == "pdf") {
        this.type = "PDF"
        this.fileurl =
          this.filePreview + encodeURIComponent(Base64.encode(item.url))
        this.toolbar = true
      } else {
        this.type = "其他"
        this.file_url =
          this.filePreview + encodeURIComponent(Base64.encode(item.url))

        // console.log('2023', item.url);
        this.toolbar = true
      }

      this.itemObj = item
      this.is_download = item.is_download
      this.$refs.customdialog.dialogopenbt()
    },
    resetFill() {
      this.imageviewurl = ""
      this.fileurl = ""
      this.file_url = ""
      this.videoviewurl = ""
    },
    getTask(data) {
      this.fileTask + data
    },

    // 查看文件夹
    seeFiles(row) {
      this.loading = true
      this.getattachmentlist(row)
      this.file_name = row.name
    },
    // 返回
    goBack() {
      this.loading = true
      this.getattachmentlist()
      this.file_name = ""
    },

    // 下载当前行
    downloadRow(row) {
      if (!row || !row.url) return
      let a = document.createElement("a")
      a.target = "_blank"
      a.download = row.name
      a.href = row.url
      a.style.display = "none"
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    // 下载
    download() {
      let row = this.itemObj
      //1.先创建一个a标签
      let a = document.createElement("a")
      a.target = "_bank"
      a.download = row.name
      //2.给a标签的href赋上下载地址
      a.href = row.url
      //3.让a标签不显示在视图中
      a.style.display = "none"
      //4.将a标签append到文档中
      document.body.appendChild(a)
      //5.a标签自点击
      a.click()
      //6.点击下载后，销毁这个节点
      document.body.removeChild(a)
    },
    close_dialog() {
      this.resetFill()
    },
    close_down() {
      this.$refs.customdialog.dialogclosebt()
      let _vueRef = this.$refs.vueRef
      if (this.type === "视频") {
        _vueRef.pause() //暂停
      }
      setTimeout(() => {
        this.itemObj = {}
        this.is_download = 0
      }, 500)
    },
    //递归调取图片参数
    loop(list) {
      list.forEach((el) => {
        if (el.children.length > 0) {
          el.children.forEach((item) => {
            if (this.isImg.includes(item.ext)) {
              this.imageviewurlList.push(item.url)
            }
          })
          this.loop(el.children)
        }
      })
      return this.imageviewurlList
    },

    // 统计分类数量
    calcStats(res) {
      this.stats.all = res.total || this.tableData.length
      this.stats.viewTotal = res.view_total || 2345
      this.stats.video = 0
      this.stats.doc = 0
      this.stats.other = 0
      this.tableData.forEach(item => {
        if (item.file_type != 1) return
        if (this.isVideo.includes(item.ext)) {
          this.stats.video++
        } else if (this.isdoc.includes(item.ext) || item.ext === 'pdf') {
          this.stats.doc++
        } else {
          this.stats.other++
        }
      })
    },

    convertSizeUnits(size) {
      if (size >= 1073741824) {
        size = Math.round((size / 1073741824) * 100) / 100 + "GB"
      } else if (size >= 1048576) {
        size = Math.round((size / 1048576) * 100) / 100 + "MB"
      } else if (size >= 1024) {
        size = Math.round((size / 1024) * 100) / 100 + "KB"
      } else {
        size = size + "字节"
      }
      return size
    },

    getattachmentlist(row) {
      if (row != null) {
        var attachment_pid = row.id
      }
      let params = {
        course_semester_sn: this.courseKey,
        type: 0,
        per_page: this.per_page, // 每页条数
        page: this.page,
        attachment_pid: attachment_pid,
      }
      this.imageviewurlList = []
      getattachmentlist(params)
        .then((response) => {
          if (response.code == 0) {
            this.loading = false
            this.tableData = response.data.data
            response.data.data.forEach((el) => {
              this.$set(el, "size", this.convertSizeUnits(el.size))
              if (this.isImg.includes(el.ext)) {
                this.imageviewurlList.push(el.url)
              }
            })
            this.total = response.data.total
            this.calcStats(response.data)
            this.loop(this.tableData)
          }
        })
        .catch((error) => {
          //console.log(error)
        })
    },
    // 分页
    //页码发生改变时
    pageChange(val) {
      this.page = val
      this.getattachmentlist()
    },

    // changeSize(data) {
    //   this.per_page = parseInt(data)

    // },
    // changePage(data) {
    //   this.page = parseInt(data)
    //   this.getattachmentlist()
    // },
    //全屏
    screen() {
      if (screenfull.isEnabled) {
        screenfull.toggle(this.$refs.myiframe)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media screen and (max-width: 640px) {
  .main-contain {
    margin-top: 10px;
    // margin-left: 10px;
    // margin-right: 10px;
    // height: 200px;
    width: 100%;
    // position: relative;
    // overflow: hidden;

    .contain {
      // position: absolute;
      width: 100%;
      height: 100%;

      .Table {
        width: 100%;

        .item-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-left: 10px;

          .elimage {
            width: 25px;
            height: 25px;
          }

          .title {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #222222;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // width: 55%;
          }
        }

        .item-middle {
          .title {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #222222;
          }
        }

        .item-right {
          .bt {
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #3d84ff;
            user-select: none;
            cursor: pointer;
          }
        }
      }
    }

    .customdialog {
      .dialogbody {
        padding: 10px;

        .image_view {
          // height: 600px;
          width: 100%;
        }

        .pdf_con {
          // position: relative;
        }

        .tip_con {
          height: 60px;
          background: #e6f7ff;
          border: 1px solid #91d5ff;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            margin-right: 10px;
            width: 20px;
            height: 20px;
            line-height: 17px;
            text-align: center;
            border-radius: 50%;
            background: #1890ff;
            color: white;
          }

          .tip_tex {
            font-size: 20px;
            font-weight: bold;
            color: #999999;
          }
        }
      }

      .dialogfooter {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    ::v-deep .cell {
      display: flex !important;
    }
  }

  .page_total {
    text-align: center;
    margin-top: 20px;

    ::v-deep .el-pagination {

      .btn-prev,
      .btn-next,
      .el-pager li {
        min-width: 28px;
        height: 28px;
        line-height: 28px;
        font-size: 12px;
      }
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .main-contain {
    margin-top: 10px;
    // margin-left: 10px;
    // margin-right: 10px;
    // height: 200px;
    width: 100%;
    // position: relative;
    // overflow: hidden;

    .contain {
      // position: absolute;
      width: 100%;
      height: 100%;

      .Table {
        width: 100%;

        .item-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-left: 10px;

          .elimage {
            width: 25px;
            height: 25px;
          }

          .title {
            margin-left: 10px;
            font-size: 12px;
            font-weight: 400;
            color: #222222;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            // width: 55%;
          }
        }

        .item-middle {
          .title {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #222222;
          }
        }

        .item-right {
          .bt {
            font-size: 15px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #3d84ff;
            user-select: none;
            cursor: pointer;
          }
        }
      }
    }

    .customdialog {
      .dialogbody {
        padding: 10px;

        .image_view {
          // height: 600px;
          width: 100%;
        }

        .pdf_con {
          // position: relative;
        }

        .tip_con {
          height: 60px;
          background: #e6f7ff;
          border: 1px solid #91d5ff;
          border-radius: 5px;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            margin-right: 10px;
            width: 20px;
            height: 20px;
            line-height: 17px;
            text-align: center;
            border-radius: 50%;
            background: #1890ff;
            color: white;
          }

          .tip_tex {
            font-size: 20px;
            font-weight: bold;
            color: #999999;
          }
        }
      }

      .dialogfooter {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    ::v-deep .cell {
      display: flex !important;
    }
  }

  .page_total {
    text-align: center;
    margin-top: 20px;
  }
}

@media screen and (min-width: 1200px) {
  .main-contain {
    background: #FFFFFF;

    .course-intro-content {

      margin-top: 10px;
      width: 100%;
      position: relative;
      min-height: 400px;
      background: url(~@/assets/course/UIout/material/material_decor_02.png) no-repeat;
      background-position: right bottom; // 装饰图片位置
      box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
      border-radius: 12px 12px 12px 12px;

      .intro-title {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 30px;

        .title-icon {
          position: absolute;
        }

        .title-text {
          font-weight: 500;
          font-size: 18px;
          color: #333333;
          text-align: left;
          font-style: normal;
          text-transform: none;
          position: relative;
          left: 5%;
        }

        i {
          margin-right: 8px;
          color: #7b5cff;
          font-size: 20px;
        }
      }

      .contain {
        // position: absolute;
        height: 100%;
        padding: 25px;
        padding-top: 5px;

        .stat-cards {
          display: flex;
          gap: 16px;
          margin-bottom: 24px;

          .stat-card {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 18px 20px;
            height: 100px;
            // border-radius: 16px;
            // background: linear-gradient(135deg, #f5f3ff 0%, #e8e4ff 100%);
            // box-shadow: 0 4px 12px rgba(106, 90, 249, 0.08);

            &.all {
              background: url(~@/assets/course/UIout/material/material_cardbg_01.png);
              background-size: cover;
              background-repeat: no-repeat;
            }

            &.video {
              background: url(~@/assets/course/UIout/material/material_cardbg_02.png);
              background-size: cover;
              background-repeat: no-repeat;
            }

            &.doc {
              background: url(~@/assets/course/UIout/material/material_cardbg_03.png);
              background-size: cover;
              background-repeat: no-repeat;
            }

            &.other {
              background: url(~@/assets/course/UIout/material/material_cardbg_04.png);
              background-size: cover;
              background-repeat: no-repeat;
            }

            &.total {
              background: url(~@/assets/course/UIout/material/material_cardbg_05.png);
              background-size: cover;
              background-repeat: no-repeat;

              .card-value {
                color: #f43f5e;
              }
            }

            .card-info {
              .card-label {
                font-weight: bold;
                font-size: 20px;
                color: #333333;
                text-align: center;
                font-style: normal;
                text-transform: none;
              }

              .card-value {
                font-size: 28px;
                font-weight: 600;
                color: #6a5af9;
                line-height: 1;
                padding-top: 25px;


                .card-unit {
                  font-size: 14px;
                  color: #999999;
                  margin-left: 4px;
                  font-weight: 400;
                }

                &.all {
                  font-weight: bold;
                  font-size: 36px;
                  color: #8070FA;
                  text-align: center;
                  font-style: normal;
                  text-transform: none;
                }

                &.video {
                  font-weight: bold;
                  font-size: 36px;
                  color: #1990FF;
                  text-align: center;
                  font-style: normal;
                  text-transform: none;
                }

                &.doc {
                  font-weight: bold;
                  font-size: 36px;
                  color: #159BA6;
                  text-align: center;
                  font-style: normal;
                  text-transform: none;
                }

                &.other {
                  font-weight: bold;
                  font-size: 36px;
                  color: #FEB313;
                  text-align: center;
                  font-style: normal;
                  text-transform: none;
                }

                &.total {
                  font-weight: bold;
                  font-size: 36px;
                  color: #F174A8;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;

                  .card-unit {
                    font-size: 16px;
                    color: #F174A8;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;
                  }
                }
              }
            }

            .card-icon {
              width: 56px;
              height: 56px;
              border-radius: 50%;
              background: rgba(255, 255, 255, 0.6);
            }
          }
        }

        .file-list {
          // background: #ffffff;
          // border-radius: 16px;
          // padding: 8px 20px;
          // box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
          // min-height: 200px;

          .file-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0;
            border-bottom: 1px solid #f0f0f0;

            &:last-child {
              border-bottom: none;
            }

            .file-info {
              display: flex;
              align-items: center;
              gap: 12px;

              .file-icon {
                width: 36px;
                height: 36px;
                flex-shrink: 0;
              }

              .file-meta {
                .file-name {
                  font-size: 15px;
                  color: #222222;
                  font-weight: 500;
                  margin-bottom: 4px;
                }

                .file-size {
                  font-size: 13px;
                  color: #999999;
                }
              }
            }

            .file-actions {
              display: flex;
              gap: 12px;

              .btn-preview,
              .btn-download {
                background: #ffffff;
                border-color: #8b5cf6;
                color: #8b5cf6;
                border-radius: 30px;
                padding: 8px 18px;
                width: 100px;
                height: 40px;
                font-weight: 500;
                font-size: 16px;

                &:hover {
                  background: #7c3aed;
                  border-color: #7c3aed;
                  color: #fff;
                }
              }

              .btn-icon {
                width: 16px;
                height: 16px;
                display: inline-block;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                margin-right: 6px;
                vertical-align: middle;
              }

              .preview-icon {
                background-image: url(~@/assets/course/UIout/material/material_ico_preview_nor.png);
                width: 25px;
                height: 25px;
              }

              .btn-preview:hover .preview-icon {
                background-image: url(~@/assets/course/UIout/material/material_ico_preview_hover.png);
                width: 25px;
                height: 25px;
              }

              .download-icon {
                background-image: url(~@/assets/course/UIout/material/material_ico_download_nor.png);
                width: 25px;
                height: 25px;
              }

              .btn-download:hover .download-icon {
                background-image: url(~@/assets/course/UIout/material/material_ico_download_hover.png);
                width: 25px;
                height: 25px;
              }

              .download-text {
                vertical-align: middle;
              }
            }
          }
        }

        // .decoration-bottom {
        //   position: absolute;
        //   right: 0;
        //   bottom: 60px;
        //   width: 220px;
        //   height: 160px;
        //   background: linear-gradient(135deg, rgba(139, 92, 246, 0.06) 0%, rgba(106, 90, 249, 0.1) 100%);
        //   border-radius: 16px;
        //   border: 1px dashed rgba(139, 92, 246, 0.2);
        //   pointer-events: none;
        // }
      }

      .customdialog {
        .dialogbody {
          padding: 10px;

          .image_view {
            // height: 600px;
            width: 100%;
          }

          .pdf_con {
            // position: relative;
          }

          .tip_con {
            height: 60px;
            background: #e6f7ff;
            border: 1px solid #91d5ff;
            border-radius: 5px;
            display: flex;
            justify-content: center;
            align-items: center;

            .icon {
              margin-right: 10px;
              width: 20px;
              height: 20px;
              line-height: 17px;
              text-align: center;
              border-radius: 50%;
              background: #1890ff;
              color: white;
            }

            .tip_tex {
              font-size: 20px;
              font-weight: bold;
              color: #999999;
            }
          }
        }

        .dialogfooter {
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      ::v-deep .cell {
        display: flex !important;
      }
    }

    .page_total {
      text-align: center;
      margin-top: 20px;
    }
  }


}
</style>
